import { Drawer } from "vaul";
import { Cross1Icon } from "@radix-ui/react-icons";
import ChevronDown from "../../../../modules/icons/ChevronDown";
import FulfilmentTypeButton from "./FulfilmentTypeButton";
import { useState } from "react";
import DeliveryNowFulfilmentContent from "./DeliveryNowFulfilmentContent";
import OneDayDeliveryFulfilmentContent from "./OneDayDeliveryFulfilmentContent";
import NextDayDeliveryFulfilmentContent from "./NextDayDeliveryFulfilmentContent";
import ScheduleDeliveryFulfilmentContent from "./ScheduleDeliveryFulfilmentContent/ScheduleDeliveryFulfilmentContent";
import classNames from "classnames";

export const FULFILMENT_TYPE_DELIVER_NOW = "FULFILMENT_TYPE_DELIVER_NOW";
export const FULFILMENT_TYPE_ONE_DAY_DELIVERY =
  "FULFILMENT_TYPE_ONE_DAY_DELIVERY";
export const FULFILMENT_TYPE_SCHEDULE_DELIVERY =
  "FULFILMENT_TYPE_SCHEDULE_DELIVERY";

const fulfilmentTypes = [
  { type: FULFILMENT_TYPE_DELIVER_NOW, label: "Delivery Now" },
  { type: FULFILMENT_TYPE_ONE_DAY_DELIVERY, label: "One-Day Delivery" },
  { type: FULFILMENT_TYPE_SCHEDULE_DELIVERY, label: "Schedule Delivery" },
];

export const fulfilmentTypesNumber = {
  FULFILMENT_TYPE_DELIVER_NOW: 0,
  FULFILMENT_TYPE_ONE_DAY_DELIVERY: 1,
  FULFILMENT_TYPE_NEXT_DAY_DELIVERY: 2,
  FULFILMENT_TYPE_SCHEDULE_DELIVERY: 3
}

function CartOrderFulfilmentDetails({
  fulfilmentType,
  setFulfilmentType,
  scheduledDate,
  setScheduledDate,
}) {
  const [isCalendarOpen, openCalendar] = useState(true);
  function handleSubmit() {}

  let tabContent = null;

  if (fulfilmentType === FULFILMENT_TYPE_DELIVER_NOW) {
    tabContent = <DeliveryNowFulfilmentContent />;
  } else if (fulfilmentType === FULFILMENT_TYPE_ONE_DAY_DELIVERY) {
    tabContent = <OneDayDeliveryFulfilmentContent />;
  } else if (fulfilmentType === FULFILMENT_TYPE_SCHEDULE_DELIVERY) {
    tabContent = (
      <ScheduleDeliveryFulfilmentContent
        isCalendarOpen={isCalendarOpen}
        openCalendar={openCalendar}
        date={scheduledDate}
        setDate={setScheduledDate}
      />
    );
  } else {
    throw new Error("Fulfilment Type not defined");
  }

  const hideContinueButton =
    fulfilmentType === FULFILMENT_TYPE_SCHEDULE_DELIVERY && isCalendarOpen;

  return (
    <Drawer.Root>
      <Drawer.Trigger className="flex items-center cursor-pointer">
        <div className="text-stone-900 text-xs font-bold mr-1">
          {fulfilmentTypes.find((f) => f.type === fulfilmentType).label}
        </div>
        <ChevronDown />
      </Drawer.Trigger>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/40" />
        <Drawer.Content className="bg-gray-100 flex flex-col rounded-t-[10px] mt-24 h-fit fixed bottom-0 left-0 right-0 outline-none">
          <div className="bg-white rounded-t-[10px] flex-1">
            {/* Header */}
            <div className="flex justify-between items-center px-5 pt-6">
              <Drawer.Title className="text-stone-900 text-sm font-bold font-custom">
                Fulfilment Type
              </Drawer.Title>

              <Drawer.Close>
                <Cross1Icon />
              </Drawer.Close>
            </div>

            {/* Tabs */}
            <div className="overflow-x-auto pl-5 mt-4">
              <div className="inline-flex gap-3 py-3">
                {fulfilmentTypes.map(({ label, type }) => (
                  <FulfilmentTypeButton
                    isActive={type === fulfilmentType}
                    key={type}
                    onClick={() => setFulfilmentType(type)}
                  >
                    {label}
                  </FulfilmentTypeButton>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="px-5 mt-6">{tabContent}</div>

            {/* CTA Button */}
            <div
              className={classNames(
                "mt-9 mb-12 mx-5",
                hideContinueButton && "hidden"
              )}
            >
              <Drawer.Close className="font-custom btn btn-block bg-[#492897] text-white rounded-[30px] text-base font-semibold disabled:cursor-not-allowed">
                Continue
              </Drawer.Close>
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}

export default CartOrderFulfilmentDetails;
